module.exports = __webpack_public_path__ + "img/technology-star2.867596fa.svg";